/* Sora Necklace builder: two pendants, each an initial or a birthstone.
   The live preview is its own slide in the product photo gallery; the picker follows the Fable flow.
   Line-item properties are sent with exactly the names and values the previous personalizer used. */
(function () {
  'use strict';
  var root = document.querySelector('[data-sora]');
  if (!root || root.__sora) return;
  root.__sora = true;
  var CFG = JSON.parse(root.getAttribute('data-cfg'));
  var GEO = {"tile":[184,228],"sc":0.6275,"letters":[[93.15,42.8,92.52,186.62],[83.8,31.89,87.1,196.83],[91.91,32.99,94.47,194.67],[84.22,31.6,85.98,197.07],[86.57,31.43,87.17,197.66],[88.5,28.83,66.24,200.82],[91.42,32.32,93.32,197.86],[56.61,32.28,129.2,197.44],[91.61,31.01,92.24,197.74],[109.9,32.06,90.14,196.54],[59.62,32.47,124.75,196.46],[65.75,29.44,88.84,201.01],[49.31,33.12,135.55,196.34],[58.32,32.8,128.91,196.8],[91.81,31.3,92.83,198.11],[87.78,32.13,64.51,197.51],[87.95,33.28,89.45,195.51],[54.58,31.37,133.24,199.34],[89.75,32.3,93.24,197.88],[91.07,32.14,93.07,197.4],[45.03,38.62,139.56,192.33],[47.08,32.11,94.6,196.96],[33.92,31.86,130.39,197.43],[52.49,33.1,131.69,197.62],[56.59,31.84,93.75,197.84],[88.76,31.57,91.49,197.66]],"curves":{"L":{"s0":-180,"ds":2,"p":[222.71,242.33,223.1,244.29,223.5,246.25,223.9,248.21,224.29,250.17,224.69,252.13,225.09,254.09,225.49,256.05,225.88,258.01,226.28,259.97,226.68,261.93,227.08,263.89,227.48,265.85,227.88,267.81,228.28,269.77,228.68,271.72,229.08,273.68,229.48,275.64,229.89,277.6,230.29,279.56,230.7,281.52,231.1,283.48,231.51,285.44,231.91,287.4,232.32,289.35,232.73,291.31,233.13,293.27,233.54,295.23,233.95,297.18,234.36,299.14,234.78,301.1,235.19,303.06,235.6,305.01,236.02,306.97,236.43,308.93,236.85,310.88,237.27,312.84,237.68,314.79,238.1,316.75,238.52,318.7,238.95,320.66,239.37,322.61,239.79,324.57,240.22,326.52,240.64,328.48,241.07,330.43,241.5,332.38,241.93,334.34,242.36,336.29,242.79,338.24,243.23,340.2,243.66,342.15,244.1,344.1,244.53,346.05,244.97,348.0,245.41,349.95,245.86,351.9,246.3,353.85,246.74,355.8,247.19,357.75,247.64,359.7,248.09,361.65,248.54,363.6,248.99,365.55,249.44,367.5,249.9,369.45,250.35,371.39,250.81,373.34,251.27,375.29,251.73,377.23,252.2,379.18,252.66,381.12,253.13,383.07,253.6,385.01,254.07,386.96,254.54,388.9,255.01,390.84,255.49,392.79,255.96,394.73,256.44,396.67,256.92,398.61,257.4,400.55,257.89,402.49,258.37,404.43,258.86,406.37,259.35,408.31,259.84,410.25,260.33,412.19,260.83,414.13,261.33,416.06,261.83,418.0,262.33,419.94,262.83,421.87,263.33,423.81,263.84,425.74,264.35,427.68,264.86,429.61,265.37,431.54,265.89,433.48,266.41,435.41,266.92,437.34,267.45,439.27,267.97,441.2,268.49,443.13,269.02,445.06,269.55,446.99,270.08,448.92,270.61,450.84,271.15,452.77,271.69,454.7,272.23,456.62,272.77,458.55,273.31,460.47,273.86,462.4,274.41,464.32,274.96,466.24,275.51,468.17,276.07,470.09,276.62,472.01,277.18,473.93,277.74,475.85,278.31,477.77,278.87,479.68,279.44,481.6,280.01,483.52,280.59,485.43,281.16,487.35,281.74,489.27,282.32,491.18,282.9,493.09,283.48,495.01,284.07,496.92,284.66,498.83,285.25,500.74,285.84,502.65,286.44,504.56,287.04,506.47,287.64,508.37,288.24,510.28,288.85,512.19,289.45,514.09,290.06,516.0,290.68,517.9,291.29,519.81,291.91,521.71,292.53,523.61,293.15,525.51,293.77,527.41,294.4,529.31,295.03,531.21,295.66,533.11,296.29,535.0,296.93,536.9,297.57,538.8,298.21,540.69,298.85,542.58,299.49,544.48,300.14,546.37,300.79,548.26,301.44,550.15,302.1,552.04,302.76,553.93,303.42,555.82,304.08,557.71,304.74,559.59,305.41,561.48,306.08,563.36,306.75,565.25,307.42,567.13,308.1,569.01,308.78,570.89,309.46,572.77,310.14,574.65,310.83,576.53,311.52,578.41,312.21,580.29,312.9,582.16,313.6,584.04,314.3,585.91,315.0,587.78,315.7,589.66],"ring":[259.8,418.5]},"R":{"s0":-180,"ds":2,"p":[856.49,250.47,856.08,252.43,855.67,254.39,855.26,256.35,854.84,258.3,854.43,260.26,854.01,262.22,853.6,264.17,853.18,266.13,852.76,268.08,852.34,270.04,851.92,271.99,851.5,273.95,851.08,275.9,850.65,277.86,850.23,279.81,849.8,281.77,849.37,283.72,848.94,285.67,848.51,287.63,848.08,289.58,847.65,291.53,847.22,293.49,846.78,295.44,846.34,297.39,845.91,299.34,845.47,301.29,845.03,303.24,844.59,305.19,844.15,307.14,843.7,309.09,843.26,311.04,842.81,312.99,842.37,314.94,841.92,316.89,841.47,318.84,841.02,320.79,840.56,322.74,840.11,324.69,839.66,326.63,839.2,328.58,838.74,330.53,838.28,332.47,837.82,334.42,837.36,336.37,836.9,338.31,836.43,340.26,835.97,342.2,835.5,344.15,835.03,346.09,834.56,348.04,834.09,349.98,833.62,351.92,833.15,353.87,832.67,355.81,832.19,357.75,831.72,359.69,831.24,361.64,830.76,363.58,830.27,365.52,829.79,367.46,829.31,369.4,828.82,371.34,828.33,373.28,827.84,375.22,827.35,377.16,826.86,379.09,826.37,381.03,825.87,382.97,825.37,384.91,824.88,386.84,824.38,388.78,823.87,390.72,823.37,392.65,822.87,394.59,822.36,396.52,821.85,398.46,821.35,400.39,820.84,402.33,820.32,404.26,819.81,406.19,819.3,408.13,818.78,410.06,818.26,411.99,817.74,413.92,817.22,415.85,816.7,417.78,816.17,419.71,815.65,421.64,815.12,423.57,814.59,425.5,814.06,427.43,813.53,429.36,813.0,431.28,812.46,433.21,811.92,435.14,811.38,437.06,810.84,438.99,810.3,440.91,809.76,442.84,809.21,444.76,808.67,446.69,808.12,448.61,807.57,450.53,807.02,452.46,806.46,454.38,805.91,456.3,805.35,458.22,804.79,460.14,804.23,462.06,803.67,463.98,803.11,465.9,802.54,467.82,801.97,469.74,801.41,471.65,800.84,473.57,800.26,475.49,799.69,477.4,799.11,479.32,798.54,481.23,797.96,483.15,797.38,485.06,796.79,486.97,796.21,488.89,795.62,490.8,795.04,492.71,794.45,494.62,793.86,496.53,793.26,498.44,792.67,500.35,792.07,502.26,791.47,504.17,790.87,506.08,790.27,507.98,789.67,509.89,789.06,511.8,788.45,513.7,787.84,515.61,787.23,517.51,786.62,519.41,786.0,521.32,785.39,523.22,784.77,525.12,784.15,527.02,783.53,528.92,782.9,530.82,782.28,532.72,781.65,534.62,781.02,536.52,780.39,538.42,779.75,540.32,779.12,542.21,778.48,544.11,777.84,546.0,777.2,547.9,776.56,549.79,775.92,551.69,775.27,553.58,774.62,555.47,773.97,557.36,773.32,559.25,772.66,561.14,772.01,563.03,771.35,564.92,770.69,566.81,770.03,568.7,769.36,570.58,768.7,572.47,768.03,574.35,767.36,576.24,766.69,578.12,766.02,580.0,765.34,581.89,764.66,583.77,763.98,585.65,763.3,587.53,762.62,589.41,761.93,591.29,761.25,593.17,760.56,595.04,759.87,596.92],"ring":[816.5,425.9]}},"hw":{"gold":{"Lt":{"sx":0,"w":34,"h":51,"x0":235,"y0":344,"J":[252.44,379.35]},"Lb":{"sx":36,"w":37,"h":50,"x0":253,"y0":441,"J":[269.89,455.77]},"Rt":{"sx":75,"w":35,"h":50,"x0":807,"y0":353,"J":[823.72,388.14]},"Rb":{"sx":112,"w":35,"h":51,"x0":786,"y0":446,"J":[804.73,461.68]},"L":{"st":-39.67,"sb":38.57,"ot":[0.17,-0.15],"ob":[-1.95,0.52]},"R":{"st":-38.55,"sb":37.42,"ot":[-0.79,-0.11],"ob":[0.33,0.18]}},"silver":{"Lt":{"sx":0,"w":34,"h":51,"x0":235,"y0":344,"J":[252.67,379.23]},"Lb":{"sx":36,"w":36,"h":50,"x0":254,"y0":441,"J":[269.94,455.82]},"Rt":{"sx":74,"w":35,"h":51,"x0":807,"y0":352,"J":[823.68,387.87]},"Rb":{"sx":111,"w":35,"h":51,"x0":786,"y0":446,"J":[804.81,461.37]},"L":{"st":-39.93,"sb":38.57,"ot":[0.46,-0.02],"ob":[-1.9,0.57]},"R":{"st":-38.81,"sb":37.16,"ot":[-0.9,-0.13],"ob":[0.34,0.12]}}},"hwlen":34};

  var LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  /* [month, stone, value exactly as it has always been sent to orders] */
  var STONES = [
    ['January', 'Garnet', 'January - Garnet'],
    ['February', 'Amethyst', 'February - Amethyst '],
    ['March', 'Aquamarine', 'March - Aquamarine'],
    ['April', 'Diamond', 'April - Diamond'],
    ['May', 'Emerald', 'May - Emerald'],
    ['June', 'Alexandrite', 'June - Alexandrite'],
    ['July', 'Ruby', 'July - Ruby'],
    ['August', 'Peridot', 'August - Peridot '],
    ['September', 'Sapphire', 'September - Sapphire'],
    ['October', 'Pink Tourmaline', 'October - Pink Tourmaline'],
    ['November', 'Topaz', 'November - Topaz'],
    ['December', 'Zircon', 'December - Zircon']
  ];
  var PROPS = [
    { choose: 'First Pendant (CHOOSE ONE)', initial: 'Initial', birthstone: 'Birthstones' },
    { choose: 'Second Pendant (CHOOSE ONE)', initial: 'Second Initial', birthstone: 'Second Birthstones' }
  ];
  var ORD = ['first', 'second'];
  var ANS = [
    { cat: 'initial', name: 'Initial', sub: 'A letter, A to Z', grid: 'initial' },
    { cat: 'birthstone', name: 'Birthstone', sub: 'For a birth month', grid: 'birthstone' }
  ];

  /* ---------- state ---------- */
  var S = { cats: [null, null], picks: [null, null], open: 0 };   // pick = {cat:'initial'|'birthstone', i:index}
  var HOV = null;                                                // {k, cat, i} while a tile is hovered (desktop)
  var q = function (s) { return root.querySelector(s); };
  var cardsEl = q('[data-sora-cards]'), progEl = q('[data-sora-progress]'), errEl = q('[data-sora-err]');

  function finishValue() {
    var r = document.querySelector('fieldset[data-handle="finish"] input:checked');
    return r ? r.value : CFG.finish;
  }
  function fin() { return /silver/i.test(finishValue()) ? 'silver' : 'gold'; }
  function firstEmpty() { for (var k = 0; k < 2; k++) if (!S.picks[k]) return k; return -1; }
  function anyPick() { return !!(S.picks[0] || S.picks[1]); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  /* ---------- picker thumbnails ---------- */
  function thumbHtml(cat, i, big) {
    var f = fin(), cls = 'sora__thumb sora__thumb--' + cat + (big ? ' is-big' : '');
    if (cat === 'initial') {
      return '<span class="sora__glyph sora__glyph--' + f + (big ? ' is-big' : '') + '" aria-hidden="true">' + LETTERS[i] + '</span>';
    }
    var ring = f === 'gold' ? 'linear-gradient(135deg,#fbe7a3 0%,#d9ac4b 45%,#b98a2e 70%,#f3d58a 100%)' : 'linear-gradient(135deg,#ffffff 0%,#c9cdd2 45%,#8f949a 70%,#e9ebee 100%)';
    return '<span class="' + cls + '"><i style="background-image:url(' + CFG.urls.stones + '),' + ring + ';background-size:1200% 100%,100% 100%;background-position:' + (i / 11 * 100) + '% 0,0 0"></i></span>';
  }
  function pickLabel(p) {
    return p.cat === 'initial' ? 'Initial: ' + LETTERS[p.i] : 'Birthstone: ' + STONES[p.i][1] + ' (' + STONES[p.i][0] + ')';
  }

  function drawCards() {
    cardsEl.innerHTML = '';
    var fe = firstEmpty(), last = fe >= 0 ? fe : 1;
    for (var k = 0; k <= last; k++) {
      var p = S.picks[k], open = k === S.open, cat = S.cats[k];
      var card = el('div', 'sora__card' + (open ? ' is-open' : '') + (p ? ' is-done' : ' is-empty'));
      card.setAttribute('data-card', k);
      var sub = p ? esc(pickLabel(p)) : (open ? '' : 'Not chosen yet');
      var cta = open ? (p ? 'Close' : '') : (p ? 'Change' : 'Choose');
      var head = el('button', 'sora__card-head',
        '<span class="sora__card-num">' + (k + 1) + '</span>' +
        '<span class="sora__card-text"><span class="sora__card-title">Pendant ' + (k + 1) + ' <small>of 2</small></span>' +
        (sub ? '<span class="sora__card-sub">' + sub + '</span>' : '') + '</span>' +
        (p ? thumbHtml(p.cat, p.i, false) : '') +
        (cta ? '<span class="sora__card-cta">' + cta + '</span>' : ''));
      head.type = 'button'; head.setAttribute('data-open', k); head.setAttribute('aria-expanded', open ? 'true' : 'false');
      card.appendChild(head);
      if (open) {
        var body = el('div', 'sora__card-body');
        body.appendChild(el('p', 'sora__q', 'What would you like on your ' + ORD[k] + ' pendant?'));
        var ans = el('div', 'sora__answers' + (cat ? ' is-compact' : ''));
        ANS.forEach(function (a) {
          var b = el('button', 'sora__ans', thumbHtml(a.cat, a.cat === 'initial' ? 0 : 3, false) + '<span class="sora__ans-text"><b>' + a.name + '</b><small>' + a.sub + '</small></span>');
          b.type = 'button'; b.setAttribute('data-cat', a.cat); b.setAttribute('data-card', k);
          b.setAttribute('aria-pressed', a.cat === cat ? 'true' : 'false');
          ans.appendChild(b);
        });
        body.appendChild(ans);
        if (cat) {
          body.appendChild(el('p', 'sora__q2', 'Choose your ' + cat + '<span class="sora__hint"> &middot; hover to see it on your necklace</span>'));
          var grid = el('div', 'sora__grid sora__grid--' + cat);
          var n = cat === 'initial' ? 26 : 12;
          for (var i = 0; i < n; i++) {
            var on = p && p.cat === cat && p.i === i;
            var lab = cat === 'initial' ? '' : '<span class="sora__tile-lab"><b>' + esc(STONES[i][1]) + '</b><small>' + STONES[i][0] + '</small></span>';
            var t = el('button', 'sora__tile sora__tile--' + cat, thumbHtml(cat, i, true) + lab);
            t.type = 'button'; t.setAttribute('data-pick', i); t.setAttribute('data-pcat', cat); t.setAttribute('data-card', k);
            t.setAttribute('aria-pressed', on ? 'true' : 'false');
            t.setAttribute('aria-label', cat === 'initial' ? 'Initial ' + LETTERS[i] : STONES[i][1] + ', ' + STONES[i][0] + ' birthstone');
            grid.appendChild(t);
          }
          body.appendChild(grid);
        }
        card.appendChild(body);
      }
      cardsEl.appendChild(card);
    }
    var done = (S.picks[0] ? 1 : 0) + (S.picks[1] ? 1 : 0);
    progEl.textContent = done === 2 ? 'Both chosen' : done + ' of 2 chosen';
  }

  /* ---------- line-item properties (same names and values the personalizer app sent) ---------- */
  function productForm() {
    var ref = document.querySelector('fieldset[data-handle="finish"] input[type="radio"]');
    var id = ref && ref.getAttribute('form');
    return (id && document.getElementById(id)) || document.querySelector('form[action*="/cart/add"][id^="product-form-"]') || document.querySelector('form[action*="/cart/add"]');
  }
  function syncProps() {
    var form = productForm(); if (!form) return;
    var box = form.querySelector('[data-sora-props]');
    if (!box) { box = document.createElement('div'); box.setAttribute('data-sora-props', ''); box.hidden = true; form.appendChild(box); }
    var rows = [];
    for (var k = 0; k < 2; k++) {
      var p = S.picks[k]; if (!p) continue;
      rows.push([PROPS[k].choose, p.cat === 'initial' ? 'Initial' : 'Birthstone']);
      rows.push(p.cat === 'initial' ? [PROPS[k].initial, LETTERS[p.i]] : [PROPS[k].birthstone, STONES[p.i][2]]);
    }
    rows.push(['_pplr_customization_id', '']);
    var sig = JSON.stringify(rows);
    if (box.getAttribute('data-sig') === sig) return;
    box.setAttribute('data-sig', sig);
    box.innerHTML = '';
    rows.forEach(function (r) {
      var inp = document.createElement('input');
      inp.type = 'hidden'; inp.name = 'properties[' + r[0] + ']'; inp.value = r[1];
      box.appendChild(inp);
    });
  }

  /* ---------- preview ---------- */
  var imgs = {};
  function load(u) {
    if (!imgs[u]) imgs[u] = new Promise(function (res, rej) {
      var im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async';
      im.onload = function () { res(im); }; im.onerror = function () { rej(new Error(u)); }; im.src = u;
    });
    return imgs[u];
  }
  function P(side, t) {
    var c = GEO.curves[side], p = c.p, n = p.length / 2, x = (t - c.s0) / c.ds;
    if (x < 0) x = 0; if (x > n - 1) x = n - 1;
    var i = Math.min(Math.floor(x), n - 2), f = x - i;
    return [p[2 * i] + f * (p[2 * i + 2] - p[2 * i]), p[2 * i + 1] + f * (p[2 * i + 3] - p[2 * i + 1])];
  }
  function band(ctx, side, s0, s1, hw) {
    var L = [], R = [], t, a, b, d, len, nx, ny, pt;
    for (t = s0; t <= s1 + 0.001; t += 2) {
      pt = P(side, t); a = P(side, t - 1); b = P(side, t + 1);
      d = [b[0] - a[0], b[1] - a[1]]; len = Math.hypot(d[0], d[1]) || 1; nx = -d[1] / len; ny = d[0] / len;
      L.push([pt[0] + nx * hw, pt[1] + ny * hw]); R.push([pt[0] - nx * hw, pt[1] - ny * hw]);
    }
    ctx.beginPath(); ctx.moveTo(L[0][0], L[0][1]);
    for (t = 1; t < L.length; t++) ctx.lineTo(L[t][0], L[t][1]);
    for (t = R.length - 1; t >= 0; t--) ctx.lineTo(R[t][0], R[t][1]);
    ctx.closePath();
  }
  function withClip(ctx, pathFn, img) { ctx.save(); pathFn(); ctx.clip(); ctx.drawImage(img, 0, 0, 1080, 1080); ctx.restore(); }
  var SIDES = ['L', 'R'], OV = 3, HW = 38, SPAN = 175;
  var STONE = { L: [259.8, 418.5, 22.2], R: [816.5, 425.9, 21.2] };
  /* A letter hangs from the chain's own end links and jump rings (the same hardware that holds the birthstone),
     slid outward along the chain until the rings sit exactly on the letter's two bail points. Every letter has
     its own bail-to-bail length, so the slide and the tilt are solved per letter. */
  function letterGeom(f, side, i) {
    var g = GEO.letters[i], h = GEO.hw[f][side], span = Math.hypot(g[2] - g[0], g[3] - g[1]) * GEO.sc, d = 0, a, b;
    for (var j = 0; j < 30; j++) {
      a = P(side, h.st - d); a = [a[0] + h.ot[0], a[1] + h.ot[1]];
      b = P(side, h.sb + d); b = [b[0] + h.ob[0], b[1] + h.ob[1]];
      d += (span - Math.hypot(b[0] - a[0], b[1] - a[1])) / 2;
    }
    return { d: d, h: h, a: a, b: b, g: g, rot: Math.atan2(b[1] - a[1], b[0] - a[0]) - Math.atan2(g[3] - g[1], g[2] - g[0]) };
  }
  function hardware(ctx, sheet, f, name, at) {
    var q = GEO.hw[f][name];
    ctx.drawImage(sheet, q.sx, 0, q.w, q.h, q.x0 + at[0] - q.J[0], q.y0 + at[1] - q.J[1], q.w, q.h);
  }
  function paint(ctx, f, picks, im) {
    var base = im[0], clean = im[1], letters = im[2], stones = im[3], hw = im[4], k, side, p, L = GEO.hwlen;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.drawImage(clean, 0, 0, 1080, 1080);
    var geo = [];
    /* 1. bring the chain (and the empty settings) back everywhere a letter isn't hanging */
    for (k = 0; k < 2; k++) {
      side = SIDES[k]; p = picks[k];
      if (p && p.cat === 'initial') {
        var G = geo[k] = letterGeom(f, side, p.i);
        withClip(ctx, function () { band(ctx, side, -SPAN, G.h.st - G.d - L + OV, HW); }, base);
        withClip(ctx, function () { band(ctx, side, G.h.sb + G.d + L - OV, SPAN, HW); }, base);
      } else {
        withClip(ctx, function () { band(ctx, side, -SPAN, SPAN, HW); }, base);
        var r = GEO.curves[side].ring;
        withClip(ctx, function () { ctx.beginPath(); ctx.arc(r[0], r[1], 62, 0, Math.PI * 2); }, base);
      }
    }
    /* 2. hang each pendant: letters on the jump rings, stones set in the bezel */
    var TW = GEO.tile[0], TH = GEO.tile[1];
    for (k = 0; k < 2; k++) {
      side = SIDES[k]; p = picks[k]; if (!p) continue;
      if (p.cat === 'initial') {
        var o = geo[k];
        ctx.save();
        ctx.translate(o.a[0], o.a[1]); ctx.rotate(o.rot); ctx.scale(GEO.sc, GEO.sc);
        ctx.drawImage(letters, p.i * TW, 0, TW, TH, -o.g[0], -o.g[1], TW, TH);
        ctx.restore();
        hardware(ctx, hw, f, side + 't', o.a);
        hardware(ctx, hw, f, side + 'b', o.b);
      } else {
        var s = STONE[side];
        ctx.save();
        ctx.beginPath(); ctx.arc(s[0], s[1], s[2], 0, Math.PI * 2); ctx.clip();
        ctx.drawImage(stones, p.i * 160, 0, 160, 160, s[0] - s[2], s[1] - s[2], s[2] * 2, s[2] * 2);
        ctx.lineWidth = 1.4; ctx.strokeStyle = f === 'gold' ? 'rgba(70,50,20,.42)' : 'rgba(60,60,64,.42)';
        ctx.beginPath(); ctx.arc(s[0], s[1], s[2] - 0.6, 0, Math.PI * 2); ctx.stroke();
        ctx.restore();
      }
    }
  }

  var cv = document.createElement('canvas'); cv.width = 1080; cv.height = 1080;
  cv.className = 'sora-preview'; cv.setAttribute('role', 'img'); cv.setAttribute('aria-label', 'Preview of your Sora necklace');
  var token = 0;

  /* ---------- the design as its own slide in the photo gallery ----------
     The slide is built in the shopper's browser only. It is never saved as product media, so product feeds,
     catalogs and ads never see it. Shoppers can swipe to the photos and back to their design, and the
     thumbnail strip gets a "Your design" thumbnail at the top. */
  var gal = (function () {
    var slide = null, thumb = null, tctx = null;
    function sl() { var s = document.getElementById('Product-Slider'); return s && s.flkty && typeof s.reInit === 'function' ? s : null; }
    function strip() { return document.getElementById('Product-Thumbnails'); }
    function sfx(id) { return (id || '').replace(/^(Slide|Thumb)-/, ''); }
    function make() {
      slide = el('div', 'product-images__slide is-active sora-slide');
      slide.id = 'Slide-sora-design';
      var media = el('div', 'product-single__media sora-slide__media');   // the theme expects this wrapper on every slide
      media.appendChild(cv);
      media.appendChild(el('span', 'sora-slide__tag', 'Your design'));
      slide.appendChild(media);
      thumb = el('div', 'product-thumbnail is-active sora-thumb');
      thumb.id = 'Thumb-sora-design';
      var tc = document.createElement('canvas'); tc.width = tc.height = 200; tctx = tc.getContext('2d');
      thumb.appendChild(tc);
      thumb.appendChild(el('span', 'sora-thumb__tag', 'Your design'));
    }
    function index() {
      var s = sl(); if (!s || !slide) return -1;
      for (var i = 0; i < s.flkty.cells.length; i++) if (s.flkty.cells[i].element === slide) return i;
      return -1;
    }
    /* slide N must match thumbnail N. After a finish change the theme puts that finish's photo in front of the
       other slides while its thumbnail stays last, so thumbnail clicks open the wrong photo; this checks for it. */
    function inOrder() {
      var s = sl(), st = strip(); if (!s || !st) return true;
      var th = st.querySelectorAll('.product-thumbnail.is-active'), cells = s.flkty.cells;
      if (th.length !== cells.length) return true;
      for (var i = 0; i < cells.length; i++) if (sfx(cells[i].element.id) !== sfx(th[i].id)) return false;
      return true;
    }
    /* rebuild the theme's slider with the slides in thumbnail order (our design first). The theme's thumbnail
       click handlers remember each photo's old position, so the thumbnails are swapped for clean copies first. */
    function rebuild() {
      var s = sl(); if (!s) return false;
      var st = strip(), holder = s.querySelector('.flickity-slider') || s;
      if (st) {
        var byId = {};
        Array.prototype.forEach.call(s.querySelectorAll('.product-images__slide'), function (e) { byId[sfx(e.id)] = e; });
        Array.prototype.forEach.call(st.querySelectorAll('.product-thumbnail'), function (t) { var e = byId[sfx(t.id)]; if (e) holder.appendChild(e); });
        Array.prototype.slice.call(st.querySelectorAll('.product-thumbnail')).forEach(function (t) {
          if (t !== thumb) t.parentNode.replaceChild(t.cloneNode(true), t);
        });
      }
      s.reInit();
      return true;
    }
    function add() {
      var s = sl(); if (!s) return false;
      if (!slide) make();
      var st = strip(); if (st) st.insertBefore(thumb, st.firstChild);
      var holder = s.querySelector('.flickity-slider') || s;
      holder.insertBefore(slide, holder.firstChild);
      return rebuild();
    }
    /* highlight the thumbnail of the slide on screen (the theme only does this when the slide changes) */
    function mark() {
      var s = sl(), st = strip(); if (!s || !st) return;
      var act = st.querySelectorAll('.product-thumbnail.is-active');
      Array.prototype.forEach.call(st.querySelectorAll('.product-thumbnail.is-initial-selected'), function (t) { t.classList.remove('is-initial-selected'); });
      if (act[s.flkty.selectedIndex]) act[s.flkty.selectedIndex].classList.add('is-initial-selected');
    }
    return {
      present: function () { return index() >= 0; },
      /* put the slide in the gallery (if it isn't already) and bring it into view */
      show: function (select) {
        if (index() < 0) { if (!add()) return false; }
        else if (!inOrder()) rebuild();
        tctx.clearRect(0, 0, 200, 200); tctx.drawImage(cv, 0, 0, 1080, 1080, 0, 0, 200, 200);
        var s = sl(), i = index();
        if (select !== false && i >= 0 && s.flkty.selectedIndex !== i) s.flkty.select(i, false, true);
        mark();
        return true;
      },
      /* nothing chosen (e.g. a hover ended before the first pick): the gallery goes back to the photos only */
      hide: function () {
        if (!slide || !slide.parentNode) return;
        slide.parentNode.removeChild(slide);
        if (thumb.parentNode) thumb.parentNode.removeChild(thumb);
        rebuild(); mark();
      },
      /* after a finish change: put the slides back in thumbnail order, keeping the photo the theme chose */
      tidy: function () {
        if (inOrder()) return;
        var s = sl(), keep = s && s.flkty.selectedElement;
        rebuild();
        s = sl(); if (s && keep) { var i = s.flkty.cells.map(function (c) { return c.element; }).indexOf(keep); if (i >= 0) s.flkty.select(i, false, true); }
        mark();
      },
      box: function () { var s = sl() || document.getElementById('Product-Slider'); return s ? s.getBoundingClientRect() : null; }
    };
  })();

  function effective() {
    var picks = S.picks.slice();
    if (HOV) picks[HOV.k] = { cat: HOV.cat, i: HOV.i };
    return picks;
  }
  var retries = 0;
  function render() {
    var picks = effective();
    if (!picks[0] && !picks[1]) { token++; gal.hide(); gal.tidy(); return; }
    var t = ++token, f = fin();
    Promise.all([load(CFG.urls.base[f]), load(CFG.urls.clean[f]), load(CFG.urls.letters[f]), load(CFG.urls.stones), load(CFG.urls.hw[f])]).then(function (im) {
      if (t !== token) return;
      paint(cv.getContext('2d'), f, picks, im);
      if (!gal.show() && retries++ < 20) setTimeout(render, 250);   // the theme's gallery isn't ready yet
    })['catch'](function (e) { if (window.console) console.warn('[sora] preview', e); });
  }
  function warm() { var f = fin(); [CFG.urls.base[f], CFG.urls.clean[f], CFG.urls.letters[f], CFG.urls.stones, CFG.urls.hw[f]].forEach(function (u) { load(u)['catch'](function () {}); }); }

  /* ---------- scrolling ---------- */
  function hh() { return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0; }
  function scrollToCard(k) {
    var c = cardsEl.querySelector('[data-card="' + k + '"]'); if (!c) return;
    var t = c.getBoundingClientRect().top, vh = window.innerHeight || document.documentElement.clientHeight;
    if (t < hh() + 10 || t > vh * 0.7) window.scrollTo({ top: Math.max(0, t + window.pageYOffset - hh() - 16), behavior: 'smooth' });
  }
  /* once both pendants are chosen, glide up to the finished necklace (skipped when it is already on screen, e.g. the sticky desktop gallery) */
  function showPreview() {
    var r = gal.box(); if (!r) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (r.height && (Math.min(r.bottom, vh) - Math.max(r.top, 0)) / r.height >= 0.6) return;
    window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - hh() - 10), behavior: 'smooth' });
  }

  /* ---------- events ---------- */
  function refresh() { drawCards(); syncProps(); errEl.hidden = true; }
  cardsEl.addEventListener('click', function (e) {
    var t = e.target;
    var pick = t.closest('button[data-pick]');
    if (pick) {
      var k = +pick.getAttribute('data-card');
      S.picks[k] = { cat: pick.getAttribute('data-pcat'), i: +pick.getAttribute('data-pick') };
      S.cats[k] = S.picks[k].cat; HOV = null;
      var fe = firstEmpty(); S.open = fe;
      refresh(); render();
      if (fe >= 0) scrollToCard(fe); else setTimeout(showPreview, 60);
      return;
    }
    var ans = t.closest('button[data-cat]');
    if (ans) { HOV = null; S.cats[+ans.getAttribute('data-card')] = ans.getAttribute('data-cat'); drawCards(); render(); return; }
    var head = t.closest('button[data-open]');
    if (head) {
      var j = +head.getAttribute('data-open'); S.open = S.open === j ? -1 : j;
      if (S.open >= 0 && !S.cats[j] && S.picks[j]) S.cats[j] = S.picks[j].cat;
      if (HOV) { HOV = null; render(); }
      drawCards();
    }
  });
  /* desktop: hovering an option shows it on the necklace in that pendant's spot */
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches, hovT;
  if (canHover) {
    cardsEl.addEventListener('mouseover', function (e) {
      var b = e.target.closest && e.target.closest('button[data-pick]');
      var next = b ? { k: +b.getAttribute('data-card'), cat: b.getAttribute('data-pcat'), i: +b.getAttribute('data-pick') } : null;
      if (!next && !HOV) return;
      if (next && HOV && next.k === HOV.k && next.cat === HOV.cat && next.i === HOV.i) return;
      clearTimeout(hovT);
      hovT = setTimeout(function () { HOV = next; render(); }, next ? 40 : 140);
    });
    cardsEl.addEventListener('mouseleave', function () { clearTimeout(hovT); if (HOV) { HOV = null; render(); } });
  }
  /* finish change: the theme swaps the photo; redraw the design in the new metal and re-skin the picker */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('fieldset[data-handle="finish"] input')) {
      drawCards(); warm(); setTimeout(render, 60);
    }
  });

  /* both pendants are required before Add to bag / Buy it now */
  function guard(e) {
    var form = productForm(); if (!form) return;
    var fe = firstEmpty(); if (fe < 0) { syncProps(); return; }
    var t = e.target;
    if (e.type === 'submit' && t !== form) return;
    if (e.type === 'click') {
      var btn = t.closest && t.closest('button[type="submit"], button[name="add"], .shopify-payment-button__button, .shopify-payment-button [role="button"]');
      if (!btn) return;
      if (!form.contains(btn) && btn.getAttribute('form') !== form.getAttribute('id')) return;
    }
    e.preventDefault(); e.stopImmediatePropagation();
    errEl.textContent = fe === 0 ? 'Choose what goes on your first pendant to continue.' : 'Choose what goes on your second pendant to finish your necklace.';
    errEl.hidden = false;
    S.open = fe; drawCards(); scrollToCard(fe);
  }
  document.addEventListener('submit', guard, true);
  document.addEventListener('click', guard, true);

  /* the theme rebuilds parts of the product area on variant change; keep our inputs and the design slide in place */
  var moT;
  new MutationObserver(function () {
    clearTimeout(moT);
    moT = setTimeout(function () { syncProps(); if (anyPick() && !gal.present()) gal.show(false); }, 50);
  }).observe(document.body, { childList: true, subtree: true });

  drawCards(); syncProps();
  if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2500 }); else setTimeout(warm, 1200);
})();
